import React from 'react';
import SolutionInstallmentExaminationPaymentContainer from 'containers/SolutionInstallmentExaminationPaymentContainer/SolutionInstallmentExaminationPaymentContainer';

export default function SolutionInstallmentExaminationPaymentPage() {
    return (
        <SolutionInstallmentExaminationPaymentContainer />
    )
}
